import { SxProps, Theme } from '@mui/material';

export const titleSX: SxProps<Theme> = {
	fontSize: {
		xs: 'var(--font-size-lg)',
		sm: 'var(--font-size-xl)',
	},
	fontWeight: '800',
	color: '#2C2C2C',
	textAlign: 'center',
};

export const subtitleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	fontWeight: 'normal',
	color: '#2C2C2C',
	textAlign: 'center',
};

export const titlecontactsSX: SxProps<Theme> = {
	fontSize: {
		xs: 'var(--font-size-body)',
		sm: 'var(--font-size-lg)',
	},
	fontWeight: 'bold',
	color: '#2C2C2C',
	textAlign: 'center',
};

export const infoSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	fontWeight: 'normal',
	color: '#2C2C2C',
	textAlign: 'center',
};
